import type { ReactionId } from "@guandan/protocol";
import thumbsUp from "../../../../assets/emoji/blob/thumbs-up.png";
import clap from "../../../../assets/emoji/blob/clap.png";
import laugh from "../../../../assets/emoji/blob/laugh.png";
import mindBlown from "../../../../assets/emoji/blob/mind-blown.png";
import joker from "../../../../assets/emoji/blob/joker.png";
import thinking from "../../../../assets/emoji/blob/thinking.png";
import sweat from "../../../../assets/emoji/blob/sweat.png";
import cry from "../../../../assets/emoji/blob/cry.png";
import party from "../../../../assets/emoji/blob/party.png";

export type ReactionLabelKey =
  | "reactionSteady"
  | "reactionClap"
  | "reactionLaugh"
  | "reactionMindBlown"
  | "reactionJoker"
  | "reactionThinking"
  | "reactionSweat"
  | "reactionCry"
  | "reactionParty";

export interface TableReactionDefinition {
  readonly id: ReactionId;
  readonly asset: string;
  readonly labelKey: ReactionLabelKey;
}

/**
 * A deliberate, game-specific set rather than a general-purpose emoji keyboard.
 * Keeping the list short makes it easy to scan during a timed hand and keeps the
 * picker at a fixed 3 by 3 layout on every phone size.
 */
export const TABLE_REACTIONS: readonly TableReactionDefinition[] = [
  { id: "steady", asset: thumbsUp, labelKey: "reactionSteady" },
  { id: "clap", asset: clap, labelKey: "reactionClap" },
  { id: "laugh", asset: laugh, labelKey: "reactionLaugh" },
  { id: "mindBlown", asset: mindBlown, labelKey: "reactionMindBlown" },
  { id: "joker", asset: joker, labelKey: "reactionJoker" },
  { id: "thinking", asset: thinking, labelKey: "reactionThinking" },
  { id: "sweat", asset: sweat, labelKey: "reactionSweat" },
  { id: "cry", asset: cry, labelKey: "reactionCry" },
  { id: "party", asset: party, labelKey: "reactionParty" },
];

const reactionById = new Map<ReactionId, TableReactionDefinition>(
  TABLE_REACTIONS.map((reaction) => [reaction.id, reaction]),
);

export function reactionDefinition(id: ReactionId): TableReactionDefinition {
  return reactionById.get(id) ?? (TABLE_REACTIONS[0] as TableReactionDefinition);
}
